export default __webpack_public_path__ + "static/media/icon-profile.fcfa6b54.svg";